import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogleLogin } = useApp();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        await completeGoogleLogin(sessionId);
        // remove hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        setError("Autentificarea cu Google a eșuat. Încearcă din nou.");
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center text-center px-4">
      <div>
        <Loader2 className="w-10 h-10 mx-auto animate-spin" style={{ color: "var(--amd-primary)" }} />
        <p className="mt-4 text-white font-semibold">Te conectăm…</p>
        {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
      </div>
    </div>
  );
}
